import React, { useState, useEffect } from 'react';
import './App.css'; 
import { auth, googleProvider } from './firebase';
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signInWithPopup,
  onAuthStateChanged,
  signOut
} from "firebase/auth";
import Navbar from './components/Navbar';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';

function App() {
  // --- QUẢN LÝ TRẠNG THÁI (Gộp lại từ code của bạn) ---
  const [isActive, setIsActive] = useState(false);      // Xoay form Register/Login
  const [showPopup, setShowPopup] = useState(false);    // Ẩn/Hiện Popup
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [user, setUser] = useState(null);               // Lưu thông tin người dùng
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Thêm cái này cho Mobile

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser) setShowPopup(false);
    });
    return () => unsubscribe();
  }, []);


  // --- THEO DÕI TRẠNG THÁI ĐĂNG NHẬP ---
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        setShowPopup(false); // Tự động đóng popup nếu đã có user
      }
    });
    return () => unsubscribe();
  }, []);

  // --- CÁC HÀM XỬ LÝ (LOGIC) ---
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("Đăng nhập thành công!");
    } catch (error) {
      alert("Lỗi đăng nhập: " + error.message);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      alert("Đăng ký thành công!");
      setIsActive(false); 
    } catch (error) {
      alert("Lỗi đăng ký: " + error.message);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      alert("Chào mừng " + result.user.displayName + "!");
    } catch (error) {
      alert("Lỗi Google Login: " + error.message);
    }
  };

  const handleLogout = () => {
    signOut(auth);
    alert("Đã đăng xuất!");
  };

  return (
    <div className="App">
      <Navbar 
        user={user} 
        handleLogout={() => signOut(auth)} 
        setShowPopup={setShowPopup} 
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />

      {/* CHỈ hiện Wrapper nếu CHƯA đăng nhập (user === null) */}
      {!user && (
        <div className={`wrapper ${isActive ? 'active' : ''} ${showPopup ? 'active-popup' : ''}`}>
          <span className="icon-close" onClick={() => setShowPopup(false)}>
            <ion-icon name="close"></ion-icon>
          </span>

        <LoginForm 
          setEmail={setEmail} 
          setPassword={setPassword} 
          handleLogin={handleLogin}
          handleGoogleLogin={handleGoogleLogin}
          setIsActive={setIsActive}
        />

        <RegisterForm 
          setEmail={setEmail} 
          setPassword={setPassword} 
          handleRegister={handleRegister}
          setIsActive={setIsActive}
        />
        </div>
      )}
    
    {/* Nếu đã đăng nhập, bạn có thể hiện một lời chào giữa màn hình hoặc nội dung khác ở đây */}
    {user && (
      <div className="welcome-content">
        <h1>Welcome back, {user.displayName || user.email}!</h1>
        <p>Bạn đã đăng nhập thành công vào hệ thống.</p>
      </div>
    )}        
    </div>
  );
}

export default App;